import request from './request'

// 系统菜单模块
// 对应后端：/api/v1/admin/sysMenu/*（表 sys_menu 后台菜单/权限菜单）

// 菜单分页查询
// 方法+URL：POST /api/v1/admin/sysMenu/page
// 对应后端 Controller/表：SysMenuController / sys_menu
// 入参 params：分页与筛选条件
// 返回：分页数据 { records, total }
export function sysMenuPage(params) {
  return request({ url: '/api/v1/admin/sysMenu/page', method: 'post', data: params })
}

// 菜单列表查询（不分页）
// 方法+URL：GET /api/v1/admin/sysMenu/list
// 对应后端 Controller/表：SysMenuController / sys_menu
// 入参：无
// 返回：sys_menu 实体数组（通常含层级关系）
export function sysMenuList() {
  return request({ url: '/api/v1/admin/sysMenu/list', method: 'get' })
}

// 当前登录管理员可访问的菜单权限（菜单 id 列表）
// 方法+URL：GET /api/v1/admin/sysMenu/my-menus
// 对应后端 Controller/表：SysMenuController / sys_role_menu（经 sys_admin_role 汇总）
// 入参：无（后端从 JWT 解析当前管理员）
// 返回：菜单 id 数组；若当前管理员无角色/无授权，后端返回 null，前端按「全部菜单」渲染
export function sysMenuMyMenus() {
  return request({ url: '/api/v1/admin/sysMenu/my-menus', method: 'get' })
}

// 菜单详情
// 方法+URL：GET /api/v1/admin/sysMenu/{id}
// 对应后端 Controller/表：SysMenuController / sys_menu
// 入参 id：菜单主键
// 返回：单条菜单记录
export function sysMenuGet(id) {
  return request({ url: '/api/v1/admin/sysMenu/' + id, method: 'get' })
}

// 新增菜单
// 方法+URL：POST /api/v1/admin/sysMenu
// 对应后端 Controller/表：SysMenuController / sys_menu
// 入参 data：菜单字段（名称、路径、图标、父级等）
// 返回：新增结果（含主键 id）
export function sysMenuSave(data) {
  return request({ url: '/api/v1/admin/sysMenu', method: 'post', data })
}

export function sysMenuUpdate(data) {
  // 后端 update 为 @PutMapping（无 /{id}），由请求体中的 id 定位
  return request({ url: '/api/v1/admin/sysMenu', method: 'put', data })
}

// 仅修改菜单名称（专用端点，避免部分字段更新把 int 字段清零）
// 方法+URL：PUT /api/v1/admin/sysMenu/{id}/name?menuName=xxx
// 对应后端 Controller/表：SysMenuController / sys_menu
// 入参：id 菜单主键，menuName 新菜单名称
// 返回：是否成功
export function sysMenuUpdateName(id, menuName) {
  return request({ url: '/api/v1/admin/sysMenu/' + id + '/name', method: 'put', params: { menuName } })
}

// 删除菜单
// 方法+URL：DELETE /api/v1/admin/sysMenu/{id}
// 对应后端 Controller/表：SysMenuController / sys_menu
// 入参 id：菜单主键
// 返回：删除结果
export function sysMenuRemove(id) {
  return request({ url: '/api/v1/admin/sysMenu/' + id, method: 'delete' })
}


